/**
 * ==========================================================================
 * Customer Dashboard Controller - Con Guardado de Metafields
 * ==========================================================================
 * 
 * CONFIGURACIÓN REQUERIDA:
 * Cambia WORKER_URL por la URL de tu Cloudflare Worker
 * 
 * ==========================================================================
 */

(function() {
  'use strict';

  // ⚠️ CAMBIAR ESTA URL POR TU WORKER DE CLOUDFLARE
  const WORKER_URL = 'https://customer-dashboard.cpuga.workers.dev/';

  const CONFIG = {
    animationDuration: 300,
    messageDisplayDuration: 5000
  };

  const elements = {};
  let customerId = null;

  // ==========================================================================
  // Initialization
  // ==========================================================================

  function cacheElements() {
    elements.dashboard = document.getElementById('customer-dashboard');
    elements.navLinks = document.querySelectorAll('.dashboard-nav__link');
    elements.sections = document.querySelectorAll('.dashboard-section');
    elements.menuToggle = document.getElementById('menu-toggle');
    elements.nav = document.getElementById('dashboard-nav');
    elements.navOverlay = document.getElementById('nav-overlay');
    elements.profileForm = document.getElementById('profile-form');
    elements.carouselTrack = document.getElementById('carousel-track');
    elements.carouselPrev = document.getElementById('carousel-prev');
    elements.carouselNext = document.getElementById('carousel-next');
    elements.carouselDots = document.getElementById('carousel-dots');
  }

  function init() {
    cacheElements();
    
    if (!elements.dashboard) return;

    const isAuthenticated = elements.dashboard.dataset.authenticated === 'true';
    if (!isAuthenticated) return;

    // Obtener customer ID del data attribute
    customerId = elements.dashboard.dataset.customerId;

    initNavigation();
    initProfileForm();
    initNotifications();
    initAccordion();
    initCarousel();
    initClubKaya();
    initWelcomeHero();

    // Animate whichever section is visible on load (orders by default, or hash target)
    if (!window.location.hash) {
      var ordersSection = document.getElementById('section-orders');
      if (ordersSection) {
        requestAnimationFrame(function() {
          animateSectionChildren(ordersSection);
        });
      }
    }
  }

  // ==========================================================================
  // Navigation
  // ==========================================================================

  function initNavigation() {
    elements.navLinks.forEach(link => {
      link.addEventListener('click', handleNavClick);
    });
    
    if (elements.menuToggle) {
      elements.menuToggle.addEventListener('click', toggleMobileMenu);
    }
    
    if (elements.navOverlay) {
      elements.navOverlay.addEventListener('click', closeMobileMenu);
    }
    
    if (window.location.hash) {
      const section = window.location.hash.substring(1);
      const validSections = ['orders', 'profile', 'help', 'notifications', 'club-kaya', 'products'];
      if (validSections.includes(section)) {
        switchSection(section);
      }
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && elements.nav?.classList.contains('dashboard-nav--open')) {
        closeMobileMenu();
      }
    });
  }

  function handleNavClick(event) {
    const target = event.currentTarget.dataset.target;
    if (target) {
      switchSection(target);
      closeMobileMenu();
    }
  }

  function switchSection(sectionName) {
    elements.navLinks.forEach(link => {
      const isActive = link.dataset.target === sectionName;
      link.classList.toggle('dashboard-nav__link--active', isActive);
      link.setAttribute('aria-current', isActive ? 'page' : 'false');
    });

    elements.sections.forEach(section => {
      const isTarget = section.dataset.section === sectionName;
      if (isTarget) {
        section.style.display = 'block';
        section.style.opacity = '0';
        section.style.transform = 'translateY(16px)';
        requestAnimationFrame(() => {
          section.style.transition = 'opacity 0.45s cubic-bezier(0.16, 1, 0.3, 1), transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
          section.style.opacity = '1';
          section.style.transform = 'translateY(0)';
          // Don't animate club-kaya children here — its own observer handles it
          if (sectionName !== 'club-kaya') {
            animateSectionChildren(section);
          }
        });
      } else {
        section.style.display = 'none';
        section.style.transform = '';
        resetSectionChildren(section);
      }
    });

    history.replaceState(null, '', `#${sectionName}`);
  }

  function toggleMobileMenu() {
    const isOpen = elements.nav.classList.toggle('dashboard-nav--open');
    elements.menuToggle.setAttribute('aria-expanded', isOpen);
    if (elements.navOverlay) {
      elements.navOverlay.classList.toggle('dashboard-nav-overlay--visible', isOpen);
    }
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  function closeMobileMenu() {
    elements.nav?.classList.remove('dashboard-nav--open');
    elements.navOverlay?.classList.remove('dashboard-nav-overlay--visible');
    if (elements.menuToggle) {
      elements.menuToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  // ==========================================================================
  // Profile Form - CON GUARDADO DE METAFIELDS
  // ==========================================================================

  // ==========================================================================
  // Welcome Hero + Animated Counters
  // ==========================================================================

  function initWelcomeHero() {
    var welcome = document.getElementById('dashboard-welcome');
    if (!welcome) return;

    // Animate stat cards with stagger
    var animItems = welcome.querySelectorAll('[data-da-animate]');
    animItems.forEach(function(el) {
      var delay = parseInt(el.getAttribute('data-da-delay') || '0', 10);
      setTimeout(function() {
        el.classList.add('da-in');
      }, delay);
    });

    // Animate number counters
    setTimeout(function() {
      animateCounters(welcome);
    }, 500);
  }

  function animateCounters(container) {
    var counters = container.querySelectorAll('[data-da-count]');
    counters.forEach(function(el) {
      var target = parseInt(el.getAttribute('data-da-count'), 10);
      if (isNaN(target) || target <= 0) {
        el.textContent = '0';
        return;
      }
      var duration = 1400;
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        // easeOutExpo
        var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);
    });
  }

  // ==========================================================================
  // Profile Form
  // ==========================================================================

  function initProfileForm() {
    if (!elements.profileForm) return;
    
    elements.profileForm.addEventListener('submit', handleProfileSubmit);
    
    const inputs = elements.profileForm.querySelectorAll('.form-input, .form-select');
    inputs.forEach(input => {
      input.addEventListener('blur', () => validateInput(input));
      input.addEventListener('input', () => {
        if (input.classList.contains('form-input--invalid')) {
          validateInput(input);
        }
      });
    });
  }

  function validateInput(input) {
    const isValid = input.checkValidity();
    input.classList.toggle('form-input--invalid', !isValid);
    return isValid;
  }

  async function handleProfileSubmit(event) {
    event.preventDefault();
    
    const submitBtn = document.getElementById('profile-submit');
    const successMsg = document.getElementById('profile-success');
    const errorMsg = document.getElementById('profile-error');
    
    // Validar todos los campos
    const inputs = elements.profileForm.querySelectorAll('.form-input, .form-select');
    let isValid = true;
    inputs.forEach(input => {
      if (!validateInput(input)) isValid = false;
    });
    
    if (!isValid) {
      showMessage(errorMsg, 'Por favor corrige los campos marcados.');
      return;
    }

    // Verificar que tenemos el customer ID
    if (!customerId) {
      showMessage(errorMsg, 'Error: No se pudo identificar tu cuenta.');
      return;
    }
    
    // Mostrar estado de carga
    submitBtn.disabled = true;
    const btnText = submitBtn.querySelector('.btn__text');
    const btnLoading = submitBtn.querySelector('.btn__loading');
    if (btnText) btnText.style.display = 'none';
    if (btnLoading) btnLoading.style.display = 'inline-flex';
    
    hideMessage(successMsg);
    hideMessage(errorMsg);
    
    try {
      // Recopilar metafields del formulario
      const metafields = [];
      
      elements.profileForm.querySelectorAll('[data-metafield]').forEach(input => {
        const metafieldKey = input.dataset.metafield;
        const [namespace, key] = metafieldKey.split('.');
        const value = input.value.trim();
        
        // Determinar el tipo basado en el campo
        let type = 'single_line_text_field';
        if (input.type === 'date') {
          type = 'date';
        }
        
        metafields.push({
          namespace,
          key,
          value,
          type
        });
      });

      // Llamar al Worker de Cloudflare
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: customerId,
          metafields: metafields
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        showMessage(successMsg, '¡Información actualizada correctamente!');
      } else {
        console.error('Error saving metafields:', result);
        showMessage(errorMsg, result.error || 'Error al guardar los cambios.');
      }
      
    } catch (error) {
      console.error('Profile save error:', error);
      showMessage(errorMsg, 'Error de conexión. Por favor intenta de nuevo.');
    } finally {
      submitBtn.disabled = false;
      if (btnText) btnText.style.display = 'inline';
      if (btnLoading) btnLoading.style.display = 'none';
    }
  }

  function showMessage(element, text) {
    if (!element) return;
    if (text) {
      const textEl = element.querySelector('span:last-child');
      if (textEl) textEl.textContent = text;
    }
    element.style.display = 'flex';
    setTimeout(() => hideMessage(element), CONFIG.messageDisplayDuration);
  }

  function hideMessage(element) {
    if (element) element.style.display = 'none';
  }

  // ==========================================================================
  // Notifications
  // ==========================================================================

  function initNotifications() {
    const toggles = document.querySelectorAll('.toggle-switch__input[data-notif-key]');
    if (toggles.length === 0) return;

    toggles.forEach(toggle => {
      toggle.addEventListener('change', handleNotificationToggle);
    });
  }

  async function handleNotificationToggle(event) {
    const toggle = event.currentTarget;
    const notifKey = toggle.dataset.notifKey;
    const isChecked = toggle.checked;
    const successMsg = document.getElementById('notifications-success');
    const errorMsg = document.getElementById('notifications-error');

    if (!customerId) {
      showMessage(errorMsg, 'Error: No se pudo identificar tu cuenta.');
      toggle.checked = !isChecked;
      return;
    }

    // Disable toggle while saving
    toggle.disabled = true;

    hideMessage(successMsg);
    hideMessage(errorMsg);

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: customerId,
          metafields: [{
            namespace: 'custom',
            key: 'notif_' + notifKey,
            value: isChecked ? 'true' : 'false',
            type: 'boolean'
          }]
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        showMessage(successMsg, isChecked
          ? 'Notificaciones activadas correctamente.'
          : 'Notificaciones desactivadas correctamente.');
      } else {
        console.error('Error saving notification preference:', result);
        showMessage(errorMsg, result.error || 'Error al guardar la preferencia.');
        toggle.checked = !isChecked;
      }
    } catch (error) {
      console.error('Notification save error:', error);
      showMessage(errorMsg, 'Error de conexión. Por favor intenta de nuevo.');
      toggle.checked = !isChecked;
    } finally {
      toggle.disabled = false;
    }
  }

  // ==========================================================================
  // FAQ Accordion
  // ==========================================================================

  function initAccordion() {
    const triggers = document.querySelectorAll('.faq-trigger');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', handleAccordionClick);
      trigger.addEventListener('keydown', handleAccordionKeydown);
    });
  }

  function handleAccordionClick(event) {
    const trigger = event.currentTarget;
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    document.querySelectorAll('.faq-trigger[aria-expanded="true"]').forEach(other => {
      if (other !== trigger) {
        const otherId = other.getAttribute('aria-controls');
        const otherContent = document.getElementById(otherId);
        other.setAttribute('aria-expanded', 'false');
        if (otherContent) otherContent.hidden = true;
      }
    });
    
    trigger.setAttribute('aria-expanded', !isExpanded);
    if (content) content.hidden = isExpanded;
  }

  function handleAccordionKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  // ==========================================================================
  // Products Carousel
  // ==========================================================================

  function initCarousel() {
    if (!elements.carouselTrack) return;
    
    const slides = elements.carouselTrack.querySelectorAll('.carousel-slide');
    if (slides.length === 0) return;
    
    let currentIndex = 0;
    let slidesPerView = getSlidesPerView();
    const totalSlides = slides.length;
    
    createCarouselDots(totalSlides, slidesPerView);
    
    if (elements.carouselPrev) {
      elements.carouselPrev.addEventListener('click', () => goToSlide(currentIndex - slidesPerView));
    }
    if (elements.carouselNext) {
      elements.carouselNext.addEventListener('click', () => goToSlide(currentIndex + slidesPerView));
    }
    
    // Touch support
    let touchStartX = 0;
    elements.carouselTrack.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    elements.carouselTrack.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
    
    // Resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newSlidesPerView = getSlidesPerView();
        if (newSlidesPerView !== slidesPerView) {
          slidesPerView = newSlidesPerView;
          createCarouselDots(totalSlides, slidesPerView);
          goToSlide(Math.min(currentIndex, totalSlides - slidesPerView));
        }
      }, 200);
    });
    
    function goToSlide(index) {
      const maxIndex = Math.max(0, totalSlides - slidesPerView);
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      
      const slide = slides[0];
      if (!slide) return;
      
      const slideWidth = slide.offsetWidth;
      const gap = parseInt(getComputedStyle(elements.carouselTrack).gap) || 16;
      const offset = currentIndex * (slideWidth + gap);
      
      elements.carouselTrack.style.transform = `translateX(-${offset}px)`;
      
      if (elements.carouselPrev) elements.carouselPrev.disabled = currentIndex === 0;
      if (elements.carouselNext) elements.carouselNext.disabled = currentIndex >= maxIndex;
      
      updateCarouselDots(currentIndex, slidesPerView);
    }
    
    goToSlide(0);
  }

  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width < 480) return 1;
    if (width < 768) return 2;
    if (width < 1024) return 3;
    return 4;
  }

  function createCarouselDots(totalSlides, slidesPerView) {
    if (!elements.carouselDots) return;
    elements.carouselDots.innerHTML = '';
    const totalDots = Math.ceil(totalSlides / slidesPerView);
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.className = `carousel-dot${i === 0 ? ' carousel-dot--active' : ''}`;
      dot.setAttribute('aria-label', `Ir al grupo ${i + 1}`);
      elements.carouselDots.appendChild(dot);
    }
  }

  function updateCarouselDots(currentIndex, slidesPerView) {
    if (!elements.carouselDots) return;
    const activeDotIndex = Math.floor(currentIndex / slidesPerView);
    const dots = elements.carouselDots.querySelectorAll('.carousel-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('carousel-dot--active', i === activeDotIndex);
    });
  }

  // ==========================================================================
  // Global Section Entrance Animations
  // ==========================================================================

  var ANIMATABLE_SELECTORS = '.section-header, .order-card, .orders-empty, .profile-hero, .profile-info-card, .profile-form, .faq-item, .help-cta, .notification-item, .notifications-description, .notifications-list, .products-carousel';

  function animateSectionChildren(section) {
    var children = section.querySelectorAll(ANIMATABLE_SELECTORS);
    children.forEach(function(child, index) {
      // Prepare
      child.style.opacity = '0';
      child.style.transform = 'translateY(22px)';
      child.style.transition = 'none';
      // Animate with stagger
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          var delay = index * 65;
          child.style.transition = 'opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1) ' + delay + 'ms, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1) ' + delay + 'ms';
          child.style.opacity = '1';
          child.style.transform = 'translateY(0)';
        });
      });
    });
  }

  function resetSectionChildren(section) {
    var children = section.querySelectorAll(ANIMATABLE_SELECTORS);
    children.forEach(function(child) {
      child.style.opacity = '';
      child.style.transform = '';
      child.style.transition = '';
    });
  }

  // ==========================================================================
  // Club Kaya — Animations
  // ==========================================================================

  function initClubKaya() {
    var section = document.getElementById('section-club-kaya');
    if (!section) return;

    var animated = false;

    function runAnimations() {
      if (animated) return;
      animated = true;

      var items = section.querySelectorAll('[data-ck-animate]');
      items.forEach(function(el) {
        var delay = parseInt(el.getAttribute('data-ck-delay') || '0', 10);
        setTimeout(function() {
          el.classList.add('ck-visible');
        }, delay);
      });

      // Progress bar fill
      var barFill = section.querySelector('.ck-progress__bar-fill');
      if (barFill) {
        var pct = barFill.getAttribute('data-ck-progress') || '65';
        barFill.style.setProperty('--ck-progress-width', pct + '%');
        setTimeout(function() {
          barFill.classList.add('ck-animate');
        }, 600);
      }
    }

    function resetAnimations() {
      animated = false;
      var items = section.querySelectorAll('[data-ck-animate]');
      items.forEach(function(el) {
        el.classList.remove('ck-visible');
      });
      var barFill = section.querySelector('.ck-progress__bar-fill');
      if (barFill) {
        barFill.classList.remove('ck-animate');
      }
    }

    // Observe when the section becomes visible (nav switch sets display:block)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'style') {
          if (section.style.display !== 'none') {
            // Small delay so the browser can paint
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                runAnimations();
              });
            });
          } else {
            resetAnimations();
          }
        }
      });
    });
    observer.observe(section, { attributes: true, attributeFilter: ['style'] });

    // If section is already visible on load (e.g. hash navigation)
    if (section.style.display !== 'none') {
      requestAnimationFrame(function() {
        runAnimations();
      });
    }
  }

  // ==========================================================================
  // Initialize
  // ==========================================================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();